import React from "react";

const ArrowDownIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>arrow-down-1-icon</title>
      <path
        d="M8 13c.4 0 .778-.158 1.06-.443l6.648-6.833c.39-.395.39-1.033 0-1.428s-1.024-.395-1.414 0L8 10.772 1.707 4.296C1.317 3.9.684 3.9.293 4.296c-.39.395-.39 1.033 0 1.428l6.646 6.833c.283.285.658.443 1.06.443z"
        fill="#fff"
        fillRule="evenodd"
      />
    </svg>
  );
};
export default ArrowDownIcon;
